var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStyledPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5771_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0301 0L2.96991 0C2.57974 -7.19089e-08 2.1934 0.0768699 1.83296 0.226218C1.47251 0.375566 1.14503 0.594464 0.869229 0.870405C0.593424 1.14635 0.374699 1.47392 0.225554 1.83442C0.0764078 2.19491 -0.000236347 2.58126 5.47477e-07 2.97138L5.47477e-07 13.0286C-0.000236347 13.4187 0.0764078 13.8051 0.225554 14.1656C0.374699 14.5261 0.593424 14.8537 0.869229 15.1296C1.14503 15.4055 1.47251 15.6244 1.83296 15.7738C2.1934 15.9231 2.57974 16 2.96991 16H13.0301C13.8179 15.9995 14.5733 15.6863 15.1302 15.1291C15.6872 14.5719 16 13.8164 16 13.0286L16 2.97138C16 2.18363 15.6872 1.42812 15.1302 0.870933C14.5733 0.313744 13.8179 0.000478001 13.0301 0ZM11.8039 10.7875C11.7998 10.9055 11.7721 11.0215 11.7226 11.1287C11.6731 11.236 11.6028 11.3323 11.5157 11.412C11.4285 11.4917 11.3264 11.5533 11.2152 11.5931C11.104 11.6329 10.986 11.6502 10.868 11.6439L6.00834 11.6439L6.00834 10.2015L9.30824 10.2015L4.41429 5.24679L5.44033 4.23349L10.3613 9.21524L10.3613 5.71377L11.8039 5.71377L11.8039 10.7875Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5771_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledPaste);
export default __webpack_public_path__ + "static/media/styled-paste.94cbd3d9a9a265e1105720fc158f78d6.svg";
export { ForwardRef as ReactComponent };